import RegisterBtnComponent from '@components/Default/Register/RegisterBtnComponent';
import SearchComponent from '@components/Default/Search/SearchComponent';
import Page from '@components/Page';
import SelectableDataComponent from '@components/SelectableDataComponent';
import { NewWorkflow } from '@helpers/Enums';
import IUnit from '@interfaces/IUnit';
import IWorkflow from '@interfaces/IWorkflow';
import WorkflowService from '@services/global/Workflow';
import newWorkflowService from '@services/graphQL/graphQLWorkflow';
import UnitService from '@services/Unit';
import { Routes } from '@src/helpers/_routes';
import NotificationComponent from '@src/helpers/_showNotifications';
import ProcessRequestsInterceptor from '@src/helpers/interceptors/ProcessRequestInterceptor';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Button, Col } from 'antd';
import * as React from 'react';
import { Redirect } from 'react-router-dom';

import Table from '../components/TableComponent';
import { LocalStorageKeys } from './App';

export interface IWorkflowsContainerProps {
}

export interface IWorkflowsContainerState {
	isLoading: boolean;
	search: string;
	tableData: IWorkflow[],
	filteredTableData: IWorkflow[],
	offset?: string,
	loadingMoreWorkflows?: boolean,
	loadingRequest?: boolean,
	serverResponse: any;
	openWorkflowRegister?: string;

	unitsData: IUnit[],
	selectedProcessId?: string;
	showUnitSelectModal: boolean;
	selectedProcessObject?: IWorkflow;
	unitsAlreadySaved: string[];
	actualUnit?: IUnit;
	originalTableData: any;
	processes: any;
}

const _formflowService: ProcessRequestsInterceptor = new ProcessRequestsInterceptor()

const tableColumns = [{
	title: 'table.workflow.name',
	dataIndex: 'name',
	key: 'name',
	class: 'name',
	width: '30%'
}, {
	title: 'table.products.createdAt',
	dataIndex: 'createdAt',
	key: 'createdAt',
}, {
	title: 'table.actions',
	dataIndex: 'action',
	key: 'action',
	width: '20%'
}];

const _workflowService: WorkflowService = new WorkflowService();
const _unitsService: UnitService = new UnitService();
const _newWorkflowService: any = new newWorkflowService()


export default class WorkflowsContainer extends React.Component<IWorkflowsContainerProps, IWorkflowsContainerState> {

	private idUnit: string;

	constructor(props: IWorkflowsContainerProps) {
		super(props);

		this.idUnit = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))

		this.state = {
			isLoading: true,
			loadingRequest: false,
			search: '',
			tableData: [],
			filteredTableData: [],
			serverResponse: undefined,
			openWorkflowRegister: undefined,
			showUnitSelectModal: false,
			unitsData: [],
			selectedProcessObject: undefined,
			unitsAlreadySaved: [],
			originalTableData: [],
			processes: []
		}

		this.registerWorkflow = this.registerWorkflow.bind(this);
		// this.getWorkflows = this.getWorkflows.bind(this);
		this.searchWorkflows = this.searchWorkflows.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.deleteWorkflow = this.deleteWorkflow.bind(this);
		this.loadMoreWorkflows = this.loadMoreWorkflows.bind(this);
		this.onEditWorkflow = this.onEditWorkflow.bind(this);
		this.getUnits = this.getUnits.bind(this);
		this.toggleUnitSelectModal = this.toggleUnitSelectModal.bind(this);
		this.onRemoveUnit = this.onRemoveUnit.bind(this);
		this.onAddUnit = this.onAddUnit.bind(this);
		this.unitAdded = this.unitAdded.bind(this);
		this.unitRemoved = this.unitRemoved.bind(this);
	}

	componentDidMount() {
		this.setState({ isLoading: true });
		this.getUnits(true);
		this.fetchWorkflows();
	}

	fetchWorkflows = async () => {
		
		const rawWorkflow = await _newWorkflowService.listWorkflows()
		
		if(rawWorkflow.listWorkflows && rawWorkflow.listWorkflows.length > 0){
			const formattedData: any = [];

			for(let workflow of rawWorkflow.listWorkflows){
				formattedData.push({
					key: workflow.id,
					id: workflow.id,
					name: workflow.name,
					createdAt: new Date(workflow.created_at).getTime() || '-'
				})
			}
			let orderedFormattedData = formattedData.sort((a: any,b: any) => b.createdAt - a.createdAt) 
			this.setState({tableData: orderedFormattedData, originalTableData: orderedFormattedData})
		}
		this.setState({ isLoading: false })
		
	}

	setUnit(unitId: string) {
		this.idUnit = unitId;
	}

	registerWorkflow() {
		this.setState({ openWorkflowRegister: '' });
	}

	async getUnits(showLoading?: boolean) {
		if (showLoading != undefined) { this.setState({ isLoading: showLoading }) };

		try {
			const data: IUnit[] = await _unitsService.listAll(['id', 'name']);


			let newUnitsData: any[] = [];
			let actualUnitObject: any;

			if (data && data.length > 0) {
				newUnitsData = data.filter((item: IUnit) => item.id != this.idUnit);

				actualUnitObject = data.find((unit: IUnit) => unit.id === this.idUnit);
			}

			this.setState({ unitsData: newUnitsData, actualUnit: actualUnitObject });
		} catch (error) {
			console.warn(error);
			this.setState({
			});
		}
		// this.getWorkflows(true, true);
	};

	// getWorkflows = async (reset: boolean, showLoading?: boolean) => {
	// 	if (showLoading != undefined) { this.setState({ isLoading: showLoading }) };

	// 	if (reset) {
	// 		this.setState({
	// 			offset: undefined
	// 		});
	// 	}
	// 	try {
	// 		const response: IPagination<IWorkflow> = await _workflowService.paging({
	// 			unit: this.idUnit,
	// 			to: undefined,
	// 			from: undefined,
	// 			search: this.state.search,
	// 			limit: 10,
	// 			offset: this.state.offset
	// 		});
	// 		console.log('a response veia', response)
	// 		let dataTableCreate: any = [];

	// 		if (!reset) {
	// 			dataTableCreate = this.state.tableData || [];
	// 		}

	// 		dataTableCreate = dataTableCreate.concat(response.items);
	// 		this.setState({ tableData: dataTableCreate, isLoading: false, offset: response.offset, loadingMoreWorkflows: false });
	// 	} catch (e) {
	// 		NotificationComponent.Notify('error', I18n.l('common.error'), e);
	// 		this.setState({ isLoading: false, loadingMoreWorkflows: false });
	// 	}
	// }

	/// Get the data from api and format to fit correctly in the table
	formatDataToTable(data: IWorkflow[]) {
		if (data === undefined || data.length === 0) { return [] };

		const formatedData: any = [];

		data.map((workflow: IWorkflow, i: number) => {
			const linkUnitInfo = (
				<Col key={i}>
					<a href="#" onClick={() => this.toggleUnitSelectModal(workflow.id || '')}>{I18n.l('table.formflow.linkUnits')}</a>
				</Col>
			);
			formatedData.push({
				key: workflow.id,
				id: workflow.id,
				name: workflow.name || "-",
				version: workflow.version || "-",
				createdAt: workflow.createdAt || "-",
				units: workflow.units,
				linkUnits: linkUnitInfo,
			})
		})

		return formatedData;
	}

	async onSubmit() {
		this.setState({ loadingRequest: true })
		try {
			this.setState({ loadingRequest: false })
		} catch (e) {
			NotificationComponent.Notify('error', I18n.l('common.error'), e);
			this.setState({ loadingRequest: false })
		}
	}

	async deleteWorkflow(id: string) {
		try {
			const { tableData } = this.state;
			await _newWorkflowService.deleteWorkflow(id);

			const nextTableData = tableData.filter((item: IWorkflow) => item.id !== id);
			const originalTableData = this.state.originalTableData.filter((item: IWorkflow) => item.id !== id);
			this.setState({
				isLoading: false,
				tableData: nextTableData,
				originalTableData
			})

		} catch (e) {
			NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), e);
		}
	}

	loadMoreWorkflows() {
		this.setState({ loadingMoreWorkflows: true });
		// this.getWorkflows(false, false);
	}

	onEditWorkflow(item: IWorkflow) {
		this.setState({ openWorkflowRegister: item.id })
	}

	onCreateWorkflow = (item: any) => {
		this.setState({ openWorkflowRegister: NewWorkflow.url })
	}

	searchWorkflows = async (event: any) => {
		event.preventDefault();
		
		const { originalTableData } = this.state
		const filteredTableData = originalTableData.filter((workflow: any) => workflow.name.includes(event.target.find.value))
		
		if (event === '') {
			await this.setState({
				tableData: this.state.originalTableData
			})
		}
		await this.setState({
			tableData: filteredTableData,
			isLoading: false,
		})
	}

	//#region UNIT SELECTION MODAL

	async toggleUnitSelectModal(processId?: string) {
		this.setState({ selectedProcessId: processId || '' })

		await this.updateSelectedProcessObject();
		if (processId) this.getProcessUnitsIds(processId);

		this.setState({
			showUnitSelectModal: !this.state.showUnitSelectModal,
		});
	}

	async updateSelectedProcessObject() {
		const { selectedProcessId, tableData } = this.state;
		let selectedProcess = undefined;
		selectedProcess = await tableData.find((item: any) => item.id === selectedProcessId);
		this.setState({ selectedProcessObject: selectedProcess });
	}

	async getProcessUnitsIds(processId: string) {
		this.setState({ unitsAlreadySaved: [] });
		const { tableData } = this.state;

		if (tableData === undefined || tableData.length === 0) {
			return;
		}
		const process = tableData.filter((item: any) => item.id == processId);
		const newUnitsSavedData: string[] = process[0].units || [];


		this.setState({ unitsAlreadySaved: newUnitsSavedData });
	}

	async onRemoveUnit(id: string) {
		const { selectedProcessId } = this.state;
		await this.setLoadingUnitData(id, true);

		if (selectedProcessId == undefined) {
			this.setLoadingUnitData(id, false);
			return;
		}
		try {
			await _workflowService.unitRemove(selectedProcessId, id, this.idUnit);
			this.unitRemoved(id);
			this.setLoadingUnitData(id, false);
		} catch (e) {
			this.setLoadingUnitData(id, false);
			console.log("On remove unit error: ", e);
			NotificationComponent.NotifyWithMoreDuration('error', I18n.l('common.error'), e);
		}
	}

	async onAddUnit(id: string) {
		const { selectedProcessId } = this.state;
		this.setLoadingUnitData(id, true);

		if (selectedProcessId == undefined) {
			this.setLoadingUnitData(id, false);
			return;
		}

		try {
			await _workflowService.unitAdd(selectedProcessId, id, this.idUnit);
			this.unitAdded(id);
			this.setLoadingUnitData(id, false);
		} catch (e) {
			this.setLoadingUnitData(id, false);
			console.log("On add unit error: ", e);
			NotificationComponent.NotifyWithMoreDuration('error', I18n.l('common.error'), e);
		}
	}

	async unitAdded(id: string) {
		const { unitsAlreadySaved } = this.state;

		const newAlreadySaved: any[] = [...unitsAlreadySaved];
		newAlreadySaved.push(id);

		this.setState({ unitsAlreadySaved: newAlreadySaved });
		this.setUnitsToUser();
	}

	async unitRemoved(id: string) {
		const { unitsAlreadySaved } = this.state;

		const newAlreadySaved: any[] = [...unitsAlreadySaved];
		const index = newAlreadySaved.indexOf(id);
		newAlreadySaved.splice(index, 1);
		this.setState({ unitsAlreadySaved: newAlreadySaved });
		this.setUnitsToUser();
	}

	setUnitsToUser() {
		const { tableData, selectedProcessId, unitsAlreadySaved } = this.state;

		if (tableData != undefined) {
			const person = tableData.filter((item: any) => item.id == selectedProcessId);
			const index = tableData.indexOf(person[0]);
			const unitsIds: string[] = [];

			unitsAlreadySaved.map((unit: any) => {
				unitsIds.push(unit.id);
			})

			let formattedTableData: any = [...tableData];
			if (formattedTableData[index] != undefined) {
				formattedTableData[index].units = unitsAlreadySaved;
			}


			this.setState({ tableData: formattedTableData });
		}
	}

	setLoadingUnitData = async (auditId: string, loading: boolean) => {
		const { unitsData } = this.state;

		const unit: any = unitsData.find((item) => {
			return item.id == auditId;
		});
		const indexOf = unitsData.indexOf(unit);

		const newUnitsData: any[] = [...unitsData];
		newUnitsData[indexOf].loading = loading;

		this.setState({ unitsData: newUnitsData });
	}

	getUnitSelectModalTitle() {
		const { selectedProcessObject } = this.state;
		if (!!selectedProcessObject) {
			return I18n.l('audits.titles.processWhatUnitWithName').replace("{name}", selectedProcessObject.name);
		}
		return I18n.l('audits.titles.processWhatUnit');
	}

	public render() {

		const {
			isLoading,
			search,
			tableData,
			filteredTableData,
			offset,
			loadingMoreWorkflows,
			loadingRequest,
			serverResponse,
			showUnitSelectModal,
			unitsAlreadySaved,
			unitsData
		} = this.state;

		if (this.state.openWorkflowRegister != undefined) {
            this.setState({ openWorkflowRegister: undefined })
            return (<Redirect
                push
                to={`${Routes.workflow}/${this.state.openWorkflowRegister}`}
                from={Routes.formflowProcess}
                strict
            />
            )
        }

		if (isLoading) {
			return (
				<Page>
					<span>{I18n.l('common.loadingTable')}</span>
				</Page>
			);
		}

		return (
			<Page>
				<Wrapper>
					<Toolbar>
						<ToolbarItem>
							<RegisterBtnComponent
								onClick={this.onCreateWorkflow}
								buttonText={I18n.l('common.register') + " " + I18n.l('labels.workflowProcess')}
							/>
						</ToolbarItem>
						<ToolbarItem>
							<SearchComponent
								onSubmit={this.searchWorkflows}
								placeholder='form.placeholders.workflowSearch'
								defaultValue={search}
								buttonText='form.buttons.search'
							/>
						</ToolbarItem>
					</Toolbar>

					{tableData.length > 0 && (
						<React.Fragment>
							<div className={'goepik-component-tablesize'}>
								<Table
									columns={tableColumns}
									data={tableData}
									onEdit={this.onEditWorkflow}
									onDelete={this.deleteWorkflow}
									noPagination={true}
									showConfirmationModal={false}
								/>
							</div>

							{offset && (
								<Button
									className="loading-more"
									type="primary"
									size='large'
									ghost
									loading={loadingMoreWorkflows}
									onClick={this.loadMoreWorkflows}>{I18n.l('common.seeMore')}</Button>
							)}
						</React.Fragment>


					)}

					{tableData.length === 0 && <p>{I18n.l('common.noResult')}</p>}

					{showUnitSelectModal && (
						<SelectableDataComponent
							title={this.getUnitSelectModalTitle()}
							data={unitsData}
							showModal={showUnitSelectModal}
							loadingData={false}
							auditorAuditsIds={unitsAlreadySaved}
							onItemRemoved={this.onRemoveUnit}
							onItemSelected={this.onAddUnit}
							serverResponse={serverResponse}
							onToggleFormModal={() => this.toggleUnitSelectModal()}

							savedDefaultValues={this.state.actualUnit ? [this.state.actualUnit.name] : undefined}
							customNoSavedItemsString={I18n.l('process.titles.noUnitsSaved')}
							customNoItemsToSaveString={I18n.l('process.titles.noUnitsToSave')}
							customNoInfoString={I18n.l('process.titles.noUnitsRegistered')}
							customWhereCreateItemsInfoString={I18n.l('process.titles.whereAddUnitInfo')}
						/>
					)}

				</Wrapper>
			</Page>
		);
	}
}

const Wrapper = styled.div`
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
`;

const Toolbar = styled.div`
    flex: 0;
    display: flex;
    flex-flow: row nowrap;
    margin-bottom: 40px;
    width: 100%;
`;

const ToolbarItem = styled.div`
    flex: 1;
    margin-left: 50px;
    
    &:first-of-type {
        flex: 0;
        margin-left: 0;
    }
`;